/**
 * --------------------------------------------------------------------------
 * Isvek (v1.0.0): index.js
 * Licensed under MIT (https://isvek.ru/main/LICENSE.md)
 * --------------------------------------------------------------------------
 */

import { getSetting, getSettings, setSetting, NAMESPACE } from './utils.js'

/**
 * URL админ-панели WordPress
 * @type {string}
 */
const ADMIN_URL = getSetting('adminUrl', '')

/**
 * Главная страница сайта
 * @type {string}
 */
const HOME_URL = getSetting('homeUrl', '')

/**
 * Пользователь авторизован
 * @type {boolean}
 */
const IS_USER_LOGGED_IN = getSetting('isUserLoggedIn', false)

/**
 * Текущий пользователь
 * @type {Object|boolean}
 */
const CURRENT_USER = getSetting('currentUser', false)

/**
 * Текущий пользователь — администратор
 * @type {boolean}
 */
const CURRENT_USER_IS_ADMIN = getSetting('currentUserIsAdmin', false)

/**
 * Nonce для сброса WP
 * @type {string}
 */
const WP_RESET_NONCE = getSetting('wpResetNonce', '')

/**
 * WooCommerce: Валюта магазина
 * @type {string|Array}
 */
const CURRENCY = getSetting('currency', [])

/**
 * WooCommerce: Единица веса
 * @type {string}
 */
const WEIGHT_UNIT = getSetting('weightUnit', '')

/**
 * WooCommerce: Страницы магазина
 * @type {Array}
 */
const STORE_PAGES = getSetting('storePages', [])

/**
 * WooCommerce: Картинка-заглушка для товара
 * @type {string}
 */
const PLACEHOLDER_IMG = getSetting('placeholderImg', '')

/**
 * WooCommerce: Меню аккаунта пользователя
 * @type {Array}
 */
const ACCOUNT_MENU = getSetting('accountMenu', [])

/**
 * WooCommerce: Nonce для Store API
 * @type {string}
 */
const WC_STORE_API_NONCE = getSetting('wcStoreApiNonce', '')

/**
 * WooCommerce: Поля по умолчанию
 * @type {string}
 */
const DEFAULT_FIELDS = getSetting('defaultFields', '')

/**
 * WooCommerce: Интеграции API
 * @type {Array}
 */
const API = getSetting('apiIntegration', [])

/**
 * Глобальный объект с настройками и утилитами
 * @typedef {Object} ApiObject
 * @property {function} getSetting
 * @property {function} getSettings
 * @property {function} setSetting
 * @property {string} ADMIN_URL
 * @property {string} HOME_URL
 * @property {boolean} IS_USER_LOGGED_IN
 * @property {Object|boolean} CURRENT_USER
 * @property {boolean} CURRENT_USER_IS_ADMIN
 * @property {string} WP_RESET_NONCE
 * @property {string|Array} CURRENCY
 * @property {string} WEIGHT_UNIT
 * @property {Array} STORE_PAGES
 * @property {string} PLACEHOLDER_IMG
 * @property {Array} ACCOUNT_MENU
 * @property {string} WC_STORE_API_NONCE
 * @property {string} DEFAULT_FIELDS
 * @property {Array} API
 */
/** @type {ApiObject} */
const api = {
  getSetting,
  getSettings,
  setSetting,
  NAMESPACE,
  ADMIN_URL,
  HOME_URL,
  IS_USER_LOGGED_IN,
  CURRENT_USER,
  CURRENT_USER_IS_ADMIN,
  WP_RESET_NONCE,
  CURRENCY,
  WEIGHT_UNIT,
  STORE_PAGES,
  PLACEHOLDER_IMG,
  ACCOUNT_MENU,
  WC_STORE_API_NONCE,
  DEFAULT_FIELDS,
  API,
}

// Вставка настроек в window (глобально)
if (typeof window !== 'undefined') {
  window[NAMESPACE] = window[NAMESPACE] || {}
  window[NAMESPACE][NAMESPACE + 'Settings'] = api
}

export {
  getSetting,
  getSettings,
  setSetting,
  NAMESPACE,
  ADMIN_URL,
  HOME_URL,
  IS_USER_LOGGED_IN,
  CURRENT_USER,
  CURRENT_USER_IS_ADMIN,
  WP_RESET_NONCE,
  CURRENCY,
  WEIGHT_UNIT,
  STORE_PAGES,
  PLACEHOLDER_IMG,
  ACCOUNT_MENU,
  WC_STORE_API_NONCE,
  DEFAULT_FIELDS,
  API,
}
export default api
